import { render, staticRenderFns } from "./asset_receive_apply_detail.vue?vue&type=template&id=13bec356&scoped=true"
import script from "./asset_receive_apply_detail.vue?vue&type=script&lang=js"
export * from "./asset_receive_apply_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bec356",
  null
  
)

export default component.exports